import AlEntityOptionLinksComponentController from './controller';
import template from './component.tpl.html';

angular
    .module('festzelt-os.modules.bo.option-links')
    .component('alEntityOptionLinks', {
        bindings: {
            entity: '<',
            entityId: '<',
            object: '<'
        },
        controller: AlEntityOptionLinksComponentController,
        controllerAs: 'vm',
        templateUrl: template
    });



// WEBPACK FOOTER //
// ./src/app/modules/bo/option-links/components/entity-option-links/component.js